"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _NotificationCenterItem = _interopRequireDefault(require("./NotificationCenterItem"));

var NotificationCenterItemsList = function NotificationCenterItemsList(_ref) {
  var newNotifications = _ref.newNotifications,
      recentNotifications = _ref.recentNotifications,
      onStatusChange = _ref.onStatusChange;
  return (0, _preact.h)("div", null, newNotifications.length ? (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "notification-center__list__title"
  }, (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.new"
  })), (0, _preact.h)("div", null, newNotifications.map(function (notification) {
    return (0, _preact.h)(_NotificationCenterItem.default, (0, _extends2.default)({
      key: notification.id,
      isNew: true,
      onStatusChange: onStatusChange
    }, notification));
  }))) : null, recentNotifications.length ? (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "notification-center__list__title notification-center__list__title--recent"
  }, (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.recent"
  })), (0, _preact.h)("div", null, recentNotifications.map(function (notification) {
    return (0, _preact.h)(_NotificationCenterItem.default, (0, _extends2.default)({
      key: notification.id,
      onStatusChange: onStatusChange
    }, notification));
  }))) : null);
};

var _default = NotificationCenterItemsList;
exports.default = _default;